import { RequirementVersionScope } from "@wingspanhq/payments/dist/interfaces";
import React from "react";

export const getContractorsCurrentValue = (
  scope: RequirementVersionScope,
  completeCount: number,
  incompleteCount: number
): {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  disabled?: boolean;
} => {
  switch (scope) {
    case RequirementVersionScope.All:
      return {
        disabled: true,
        primary: "—",
        secondary: "None (all transitioning to new)"
      };
    case RequirementVersionScope.IncompleteAndNew:
      return { primary: `${completeCount} complete` };
    case RequirementVersionScope.NewOnly:
      return {
        primary: `${completeCount} complete`,
        secondary: `${incompleteCount} incomplete`
      };
  }
};

export const getContractorsNewValue = (
  scope: RequirementVersionScope,
  completeCount: number,
  incompleteCount: number
): { primary: React.ReactNode; secondary?: React.ReactNode } => {
  switch (scope) {
    case RequirementVersionScope.All:
      return {
        primary: React.createElement(
          React.Fragment,
          null,
          `${completeCount} complete`,
          React.createElement("br"),
          `${incompleteCount} incomplete`
        ),
        secondary: "+ new assignments"
      };
    case RequirementVersionScope.IncompleteAndNew:
      return {
        primary: `${incompleteCount} incomplete`,
        secondary: "+ new assignments"
      };
    case RequirementVersionScope.NewOnly:
      return { primary: "New assignments" };
  }
};
